const template = `
  mutation PostSetAsFirstCover($postId: ID!, $isCancel: Boolean) {
    postSetAsFirstCover(postId: $postId, isCancel: $isCancel)
  }
`

export default async function postCover({ postId, isCancel }) {
  await request(template, { postId, isCancel })
}
